/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import './index.scss'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { Row, Col, Modal, Input, Form } from 'antd'
import { compose } from 'recompose'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}

		this.handleSubmit = this.handleSubmit.bind(this)
	}

	handleSubmit(e) {
		e.preventDefault()
		const { form, onSubmit } = this.props
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}
			onSubmit(values)
		})
	}

	render() {
		const { visible, onCancel, form, isSaving } = this.props
		const { getFieldDecorator } = form

		return (
			<Modal
				title='Manual Log'
				width='35%'
				visible={visible}
				onCancel={onCancel}
				onOk={this.handleSubmit}
				okText='Submit'
				confirmLoading={isSaving}
				maskClosable={!isSaving}
				destroyOnClose
			>
				<Form onSubmit={this.handleSubmit}>
					<Row>
						<Form.Item label='ID Number'>
							{ getFieldDecorator('id_number', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter ID Number' />
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='4-Digits Pin Code'>
							{ getFieldDecorator('pin_code', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Pin Code' type='password' maxLength={4} />
							)}
						</Form.Item>
					</Row>
				</Form>
			</Modal>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	Form.create({ name: 'form-manual-log' }),
	observer
)

export default composed(Index)
